<script>
export default {
  methods: {
    textListValue(textList, key) {
      if (textList) {
        const item = textList.find((textListItem) =>
          textListItem.Key === key || textListItem.AttributeKey === key ? textListItem.Value : null,
        );

        if (item) {
          return item.Value;
        }
      }

      return null;
    },
  },
};
</script>
